// 3rd
import { Model } from '@vuex-orm/core';

export default class NewsCategory extends Model {
    static entity = 'news-categories';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
        }
    }
}
